import React, { ReactNode } from "react";
import { Button } from "src/components/ui/Button";
import UserProfileMenu from "src/components/UserProfileMenu";
import HorizontalDivider from "./HorizontalDivider";

interface UserNavbarProps {
  title: string;
  description?: ReactNode;
  isAdmin?: boolean;
  isAdminPage?: boolean;
  actions?: ReactNode;
  className?: string;
}

/**
 * A generic navbar component for user interfaces that can be used across all user types
 * (admin, student, tutor) and their respective pages.
 */
const UserNavbar: React.FC<UserNavbarProps> = ({
  title,
  description,
  isAdmin = false,
  isAdminPage = false,
  actions,
  className = "",
}) => {
  return (
    <header className={`bg-white relative ${className}`}>
      <div className="px-4 py-4">
        <div className="flex justify-between items-center">
          <div className="flex flex-col gap-1">
            <div className="flex items-center gap-3">
              <h1 className="text-2xl font-bold">{title}</h1>
              {actions}
            </div>
            {description && (
              <div className="text-gray-500 text-sm">{description}</div>
            )}
          </div>
          <div className="flex items-center space-x-4">
            <UserProfileMenu
              isAdmin={isAdmin}
              isAdminPage={isAdminPage}
            />
          </div>
        </div>
      </div>
      <HorizontalDivider noMargin={true} />
    </header>
  );
};

export default UserNavbar;
